import React from 'react';
import { Printer, Laptop, ShoppingBag, Stamp, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const AllInOne = () => {
  const services = [
    {
      icon: Printer,
      title: "Gráfica Rápida",
      description: "Impressões, cópias, encadernação, plastificação, cartões, panfletos, banners, adesivos, fotos e personalizados.",
      color: "from-[#1e3a8a] to-[#3b82f6]",
      link: "servicos"
    },
    {
      icon: Laptop,
      title: "Assistência Técnica",
      description: "Conserto de computadores, notebooks e impressoras, formatação, upgrades, limpeza e manutenção.",
      color: "from-[#059669] to-[#10b981]",
      link: "servicos"
    },
    {
      icon: ShoppingBag,
      title: "Papelaria",
      description: "Materiais escolares e de escritório para uso pessoal e empresarial.",
      color: "from-[#f97316] to-[#fb923c]",
      link: "papelaria"
    },
    {
      icon: Stamp,
      title: "Carimbos",
      description: "Carimbos personalizados para empresas e profissionais.",
      color: "from-[#8b5cf6] to-[#a78bfa]",
      link: "carimbos"
    }
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-[#1e3a8a]/10 rounded-full">
            <p className="text-[#1e3a8a] text-sm font-semibold">SERVIÇOS COMPLETOS</p>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Tudo o Que Você Precisa em Um Só Lugar
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Soluções completas em Fortaleza para empresas, profissionais e estudantes
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card 
                key={index}
                className="group hover:shadow-2xl transition-all duration-300 border-gray-200 hover:-translate-y-2"
              >
                <CardContent className="p-6 text-center h-full flex flex-col">
                  <div className={`w-16 h-16 bg-gradient-to-br ${service.color} rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform`}>
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed flex-grow">
                    {service.description}
                  </p>
                  <Button
                    onClick={() => scrollToSection(service.link)}
                    variant="outline"
                    className="w-full border-2 border-gray-200 hover:border-[#1e3a8a] hover:bg-[#1e3a8a] hover:text-white transition-all"
                  >
                    Saiba mais
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AllInOne;
